module.exports = __webpack_public_path__ + "static/img/mobile_hwsq_banner.5b6ea71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobile_hwsq_banner.png
// module id = tMSt
// module chunks = 21